import React from "react";
import {StoreyIndicatorsContext} from "./storey-indicators-context-props.ts";

const useStoreyIndicatorsContext = () => {
    const indicatorsContext = React.useContext(StoreyIndicatorsContext);
    if (indicatorsContext === undefined) {
        throw new Error('useStoreyIndicatorsContext must be used within a StoreyIndicatorsProvider');
    }
    return indicatorsContext;
}

export default useStoreyIndicatorsContext;